import { FuelButton } from '@frete.com/fuel-react'
import { Props } from './interfaces'
import * as Styled from './styled'
import useAccordionItem from './hooks/useAccordionItem'

function AccordionItem({ header, content, onChange, isOpen, element }: Props) {
  const { accRef, headAccRef, isVisible, useAccordionHeaderHeight, useAccordionHeight } = useAccordionItem(isOpen)

  return (
    <Styled.ContainerAccordion>
      <Styled.ContainerHeaderAccordion ref={headAccRef}>
        <Styled.HeaderAccordion>
          <Styled.ContentHeader>{header}</Styled.ContentHeader>

          <Styled.AccordionButton>
            <FuelButton
              onlyIcon
              aria-label="back"
              variant="subtle"
              data-testid={`accordion-${element + 1}-toggle`}
              leadingIcon={isOpen ? 'chevron-up' : 'chevron-down'}
              onClick={onChange}
            />
          </Styled.AccordionButton>
        </Styled.HeaderAccordion>
        {isOpen && <Styled.Divider data-testid={`accordion-${element + 1}-open`} />}
      </Styled.ContainerHeaderAccordion>
      <Styled.ContentAccordion
        style={{
          maxHeight: useAccordionHeight,
          scrollMarginTop: useAccordionHeaderHeight,
          display: useAccordionHeight ? 'block' : 'none',
        }}
        isOpen={isVisible}
        ref={accRef}
      >
        {content}
      </Styled.ContentAccordion>
    </Styled.ContainerAccordion>
  )
}

export default AccordionItem
